<div class="arrow-main-container" [class]="themeService.getTheme()">
  <app-icon
    (click)="emitClick.emit()"
    [icon]="Icons.squareArrow"
    [ngClass]="{'arrow-left': !right }"
    [invert]="getInvert()"
    class="arrow-container arrow-left"
  />
</div>

